"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var V2NavL2Panel = function V2NavL2Panel(props) {
  var className = props.className,
    xfNavHtml = props.xfNavHtml;
  var createMarkup = function createMarkup(htmlData) {
    return {
      __html: htmlData
    };
  };
  function myXfMenu(htmlData) {
    return _react.default.createElement("div", {
      dangerouslySetInnerHTML: createMarkup(htmlData)
    });
  }
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: className
  }, xfNavHtml && myXfMenu(xfNavHtml)));
};
var _default = V2NavL2Panel;
exports.default = _default;
module.exports = exports["default"];